TrelloModel = require 'models/internal/trello-model'

module.exports = class CustomSticker extends TrelloModel
  typeName: 'CustomSticker'



// WEBPACK FOOTER //
// ./app/scripts/models/custom-sticker.coffee